<!-- 下面--面包屑标签栏 -->
<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPaneRef" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link v-for="tag in visitedViews" :key="tag.path" :data-path="tag.path"
        :class="isActive(tag) ? 'active' : ''" :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        class="tags-view-item" :style="activeStyle(tag)" @click.middle="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @contextmenu.prevent="openMenu(tag, $event)">
        {{ tag.title }}
        <span v-if="!isAffix(tag)" @click.prevent.stop="closeSelectedTag(tag)">
          <close class="el-icon-close" style="width: 1em; height: 1em;vertical-align: middle;" />
        </span>
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">
        <refresh-right style="width: 1em; height: 1em;" /> 刷新页面
      </li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">
        <close style="width: 1em; height: 1em;" /> 关闭当前
      </li>
      <li @click="closeOthersTags">
        <circle-close style="width: 1em; height: 1em;" /> 关闭其他
      </li>
      <li v-if="!isFirstView()" @click="closeLeftTags">
        <back style="width: 1em; height: 1em;" /> 关闭左侧
      </li>
      <li v-if="!isLastView()" @click="closeRightTags">
        <right style="width: 1em; height: 1em;" /> 关闭右侧
      </li>
      <li @click="closeAllTags(selectedTag)">
        <circle-close style="width: 1em; height: 1em;" /> 全部关闭
      </li>
    </ul>
  </div>
</template>

<script setup>
import ScrollPane from './ScrollPane'
import { getNormalPath } from '@/utils/ruoyi'
import useTagsViewStore from '@/store/modules/tagsView'
// import useSettingsStore from '@/store/modules/settings'
import usePermissionStore from '@/store/modules/permission'

const visible = ref(false);
const top = ref(0);
const left = ref(0);
const selectedTag = ref({});
const affixTags = ref([]);
const scrollPaneRef = ref(null);

const { proxy } = getCurrentInstance();
const route = useRoute();
const router = useRouter();

const visitedViews = computed(() => useTagsViewStore().visitedViews);
const routes = computed(() => usePermissionStore().routes);
// const theme = computed(() => useSettingsStore().theme);

watch(route, () => {
  // console.log(route);
  // if(!route?.meta?.activeMenu){
  addTags()
  moveToCurrentTag()
  // }
})

watch(visible, (value) => {
  if (value) {
    document.body.addEventListener('click', closeMenu)
  } else {
    document.body.removeEventListener('click', closeMenu)
  }
})

onMounted(() => {
  initTags()
  addTags()
})

function isActive(r) {
  // 如果当前路由包含 noTagsView 参数，则使用 activeMenu 或 parentPath 配置的父级路径
  if (route.query?.noTagsView || route.meta?.noTagsView) {
    // 优先使用 activeMenu 配置，如果没有则使用 parentPath
    const parentPath = route.meta?.activeMenu || route.meta?.parentPath
    if (parentPath) {
      return r.path === parentPath
    }
    // 如果没有配置父级路径，则查找最近访问的非详情页面
    const mainView = visitedViews.value.find(view =>
      !view.query?.noTagsView && !view.meta?.noTagsView
    )
    return mainView ? r.path === mainView.path : false
  }
  return r.path === route.path
}

function activeStyle(tag) {
  if (!isActive(tag)) return {};
  // return {
  //   "background-color": theme.value,
  //   "border-color": theme.value
  // };
}

function isAffix(tag) {
  return tag.meta && tag.meta.affix
}

function isFirstView() {
  try {
    return selectedTag.value.fullPath === '/resource/siteList' || selectedTag.value.fullPath === visitedViews.value[1].fullPath
  } catch (err) {
    return false
  }
}

function isLastView() {
  try {
    return selectedTag.value.fullPath === visitedViews.value[visitedViews.value.length - 1].fullPath
  } catch (err) {
    return false
  }
}

function filterAffixTags(routes, basePath = '') {
  let tags = []
  routes.forEach(route => {
    if (route.meta && route.meta.affix) {
      const tagPath = getNormalPath(basePath + '/' + route.path)
      tags.push({
        fullPath: tagPath,
        path: tagPath,
        name: route.name,
        meta: { ...route.meta }
      })
    }
    if (route.children) {
      const tempTags = filterAffixTags(route.children, route.path)
      if (tempTags.length >= 1) {
        tags = [...tags, ...tempTags]
      }
    }
  })
  return tags
}

function initTags() {
  const res = filterAffixTags(routes.value);
  affixTags.value = res;
  for (const tag of res) {
    // Must have tag name
    if (tag.name) {
      useTagsViewStore().addVisitedView(tag)
    }
  }
}

function addTags() {
  const { name, meta, query } = route
  // 原有逻辑保持不变
  if (name && !meta?.noTagsView && !query?.noTagsView) {
    useTagsViewStore().addView(route)
  }
  // // 新增逻辑：处理noTagsView为true但有activeMenu的情况
  // else if (name && (meta?.noTagsView || query?.noTagsView) && meta?.activeMenu) {
  //   const path = meta.activeMenu;
  //   const result = path.split('/');
  //   const extracted = result ? '/' + result[1] : path;
  //   // 根据activeMenu查找对应的父级路由
  //   const parentRoute = findParentRoute(routes.value, extracted);
  //   if (parentRoute) {
  //     let childRoute = parentRoute.children.find(childRoute => childRoute.path === result[2]);
  //     // 构造父级路由对象
  //     const childRouteObj = {
  //       name: childRoute.name,
  //       path: childRoute.path,
  //       meta: { ...childRoute.meta },
  //       fullPath: childRoute.path,
  //       title: childRoute.meta?.title || childRoute.name
  //     };

  //     // 添加父级路由到标签视图
  //     useTagsViewStore().addView(childRouteObj);
  //   }
  // }
}
// 辅助函数：根据路径查找父级路由
function findParentRoute(routes, path) {
  for (const route of routes) {
    if (route.path === path) {
      return route;
    }
    if (route.children) {
      const found = findParentRoute(route.children, path);
      if (found) {
        return found;
      }
    }
  }
  return null;
}
function moveToCurrentTag() {
  nextTick(() => {
    // 如果当前路由包含 noTagsView 参数，则不进行滚动和更新
    if (route.query?.noTagsView || route.meta?.noTagsView) {
      return
    }

    for (const r of visitedViews.value) {
      if (r.path === route.path) {
        scrollPaneRef.value.moveToTarget(r);
        // when query is different then update
        if (r.fullPath !== route.fullPath) {
          useTagsViewStore().updateVisitedView(route)
        }
      }
    }
  })
}

function refreshSelectedTag(view) {
  proxy.$tab.refreshPage(view);
  if (route.meta.link) {
    useTagsViewStore().delIframeView(route);
  }
}

function closeSelectedTag(view) {
  proxy.$tab.closePage(view).then(({ visitedViews }) => {
    if (isActive(view)) {
      toLastView(visitedViews, view)
    }
  })
}

function closeRightTags() {
  proxy.$tab.closeRightPage(selectedTag.value).then(visitedViews => {
    if (!visitedViews.find(i => i.fullPath === route.fullPath)) {
      toLastView(visitedViews)
    }
  })
}

function closeLeftTags() {
  proxy.$tab.closeLeftPage(selectedTag.value).then(visitedViews => {
    if (!visitedViews.find(i => i.fullPath === route.fullPath)) {
      toLastView(visitedViews)
    }
  })
}

function closeOthersTags() {
  router.push(selectedTag.value).catch(() => { });
  proxy.$tab.closeOtherPage(selectedTag.value).then(() => {
    moveToCurrentTag()
  })
}

function closeAllTags(view) {
  proxy.$tab.closeAllPage().then(({ visitedViews }) => {
    if (affixTags.value.some(tag => tag.path === route.path)) {
      return
    }
    toLastView(visitedViews, view)
  })
}

function toLastView(visitedViews, view) {
  const latestView = visitedViews.slice(-1)[0]
  if (latestView) {
    router.push(latestView.fullPath)
  } else {
    // now the default is to redirect to the home page if there is no tags-view,
    // you can adjust it according to your needs.
    if (view.name === 'Dashboard') {
      // to reload home page
      router.replace({ path: '/redirect' + view.fullPath })
    } else {
      router.push('/')
    }
  }
}

function openMenu(tag, e) {
  const menuMinWidth = 105
  const offsetLeft = proxy.$el.getBoundingClientRect().left // container margin left
  const offsetWidth = proxy.$el.offsetWidth // container width
  const maxLeft = offsetWidth - menuMinWidth // left boundary
  const l = e.clientX - offsetLeft + 15 // 15: margin right

  if (l > maxLeft) {
    left.value = maxLeft
  } else {
    left.value = l
  }

  top.value = e.clientY
  visible.value = true
  selectedTag.value = tag
}

function closeMenu() {
  visible.value = false
}

function handleScroll() {
  closeMenu()
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  width: 100%;
  padding: 0 24px 9px 24px;
  background: var(--tags-box-bg);

  .tags-view-wrapper {

    :deep(.el-scrollbar__view) {
      display: flex;
      gap: 8px;
    }

    .tags-view-item {
      position: relative;
      cursor: pointer;
      display: flex;
      height: 28px;
      align-items: center;
      justify-content: center;
      padding: 0 8px;
      background-color: var(--tags-item-bg);
      font-family: pingFangSC-Regular;
      font-size: 14px;
      color: var(--tags-item-text-color);
      border-radius: 4px;

      &.active {
        background-color: var(--tags-item-active-bg);
        color: var(--tags-item-active-text-color);
      }

      &:hover:not(.active) {
        background-color: var(--tags-item-hover-bg);
        color: var(--tags-item-hover-text-color);
      }

      .el-icon-close:hover {
        transform: scale(1.3);
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: var(--el-bg-color-overlay, #fff);
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: var(--tags-item-text, #333);
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    border: 1px solid var(--el-border-color-light, #e4e7ed);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: var(--tags-item-hover, #eee);
      }
    }
  }
}
</style>